import { render, staticRenderFns } from "./HeadTaggingsTypesList.vue?vue&type=template&id=54f1dfdf&scoped=true&"
import script from "./HeadTaggingsTypesList.vue?vue&type=script&lang=js&"
export * from "./HeadTaggingsTypesList.vue?vue&type=script&lang=js&"
import style0 from "./HeadTaggingsTypesList.vue?vue&type=style&index=0&id=54f1dfdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f1dfdf",
  null
  
)

export default component.exports